export function isAnswerEnrichmentAction(action) {
  const key = String(action?.key || '');
  const path = String(action?.endpoint?.path || '');
  return key.startsWith('answer_by_enriching') || path.includes('/actions/answer_by_enriching/');
}

export function isStrategicEnrichmentAction(action) {
  const key = String(action?.key || action?.action_key || '');
  const path = String(action?.endpoint?.path || '');
  return key.startsWith('enhance_company_data') || path.includes('/actions/enhance_company_data/');
}
